import { render, staticRenderFns } from "./AppChannelFeeListView.vue?vue&type=template&id=cd1c11b2&"
import script from "./AppChannelFeeListView.vue?vue&type=script&lang=js&"
export * from "./AppChannelFeeListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports